import { type Api, getWorkflow } from "api-client";
import { addDaysToCivilDate } from "utils";

import {
  type CalendarDateRange,
  type CalendarWeekRange,
  CALENDAR_INITIAL_VISIBLE_WEEK_COUNT,
  getCalendarInitialWeeks,
  getCalendarWeekRangeDates,
} from "src/calendar/calendarWeeks";

export interface WorkflowInitialData {
  workflow: Api.GetWorkflow.Output.Self;
  weeks: CalendarWeekRange | null;
}

export async function fetchWorkflowInitialData(
  workflowId: string,
  initialWeekIndex: number,
): Promise<WorkflowInitialData> {
  const weeks = getCalendarInitialWeeks(
    initialWeekIndex,
    CALENDAR_INITIAL_VISIBLE_WEEK_COUNT,
  );
  const workflow = await fetchWorkflowRange(
    workflowId,
    getCalendarWeekRangeDates(weeks),
  );

  return {
    workflow,
    weeks: workflow.type === "DATED" ? weeks : null,
  };
}

export async function fetchWorkflowRange(
  workflowId: string,
  range: CalendarDateRange,
): Promise<Api.GetWorkflow.Output.Self> {
  const response = await getWorkflow({
    path: { id: workflowId },
    query: {
      startDate: range.startDate,
      endDate: addDaysToCivilDate(range.endDate, -1),
    },
  });
  return response.data.data;
}
